import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikServo extends ASTBlock {
    constructor(color) {
        super(color, "alvik_servo")
        this.predefinedInputs = {
            "position": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "setze Servo %1 auf %2 ° %3",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "servo",
                    "options": [
                        [
                            "A",
                            "A"
                        ],
                        [
                            "B",
                            "B"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "position",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}